module.exports = __webpack_public_path__ + "static/media/seat-sl-occupied.578151d7.svg";